import React, { useState } from "react"
import { Link } from "react-router-dom";
import { AccountsModal } from './AccountsModal'

export const AccountSelect = ({accounts, setAccount, errorToast}) => {
    const [accountsModal, setAccountsModal] = useState<boolean>(false);

    return (accounts?.length > 1 ?
        <div style={{paddingRight: "25px", alignSelf: "flex-end"}}>
            {accountsModal &&
                <AccountsModal 
                    hide={() => {
                        setAccountsModal(false);
                    }}
                    show={accountsModal}
                    accounts={accounts}
                    setAccount={setAccount}
                    errorToast={errorToast} />
            }
            <Link to="#" onClick={() => setAccountsModal(true)}>Switch Account</Link>
        </div>
    : <></>)
};